import { Injectable } from "@angular/core";
import { NestApiProvider } from "../../nest-api";
import { RequestDownloadExcelDto, RequestDownloadPdfDto } from "../dto/attendance-report.dto";

@Injectable()
export class AttendanceLocationReportApi {

  private service: string = '';
  private model: string = 'attendanceRadiusLocationsReport';

  constructor(
    private nestApiProvider: NestApiProvider
  ) {

  }

  downloadExcel(data: RequestDownloadExcelDto) {
    const method: string = 'POST';
    const func: string = 'downloadExcel';
    const params: RequestDownloadExcelDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
  }

  downloadPdf(data: RequestDownloadPdfDto) {
    const method: string = 'POST';
    const func: string = 'downloadPdf';
    const params: RequestDownloadPdfDto = data;
    const urlParams: any = {};
    const body: any = {};
    const url = this.nestApiProvider.urlBuilder(method, this.model, func, params, urlParams, this.service);
    return this.nestApiProvider.requestBlob(method, url, params, urlParams, body);
  }

}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/attendance-location-report.api.ts